"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.set = void 0;
const get_zaraz_1 = require("../helpers/get-zaraz");
/**
 * Set the consent status for some purposes using the purpose ID.
 */
function set(consentPreferences) {
    (0, get_zaraz_1.getZaraz)().consent.set(consentPreferences);
}
exports.set = set;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2V0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NvbnNlbnQvc2V0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLG9EQUFnRDtBQUVoRDs7R0FFRztBQUNILFNBQWdCLEdBQUcsQ0FBQyxrQkFBOEM7SUFDaEUsSUFBQSxvQkFBUSxHQUFFLENBQUMsT0FBTyxDQUFDLEdBQUcsQ0FBQyxrQkFBa0IsQ0FBQyxDQUFDO0FBQzdDLENBQUM7QUFGRCxrQkFFQyJ9